let parser = new DOMParser();

const initCollectionTabs = (scope = document) => {
  const sections = scope.querySelectorAll(".section__collections-list[data-section-id]");

  sections.forEach((section) => {
    if (section.dataset.tabsInitialized === "true") return;

    const buttons = Array.from(
      section.querySelectorAll(".collection-button[data-collection-handle]")
    );
    const panels = Array.from(
      section.querySelectorAll(".collection-panel[data-collection-handle]")
    );

    if (!buttons.length || !panels.length) return;
    const panelObservers = new Map();

    const initPanelPagination = (panel) => {
      if (!panel || panel.dataset.paginationInitialized === "true") return;

      const loadMoreButton = panel.querySelector(".collection-panel-load-more");
      const loadMoreAmount = panel.querySelector(".collection-panel-load-more-amount");
      const progressBar = panel.querySelector(".collection-panel-load-more-progress");
      if (!loadMoreButton) return;

      const step = parseInt(loadMoreButton.dataset.step || "8", 10);
      const totalCount = parseInt(
        loadMoreAmount?.dataset.count || panel.querySelectorAll(".collection-tab-item").length,
        10
      );

      const getHiddenItems = () =>
        Array.from(panel.querySelectorAll(".collection-tab-item.is-hidden-by-pagination"));
      const getVisibleCount = () =>
        panel.querySelectorAll(".collection-tab-item:not(.is-hidden-by-pagination)").length;

      const updatePanelProgress = () => {
        const visibleCount = getVisibleCount();
        const safeTotal = totalCount > 0 ? totalCount : 1;
        const percent = (visibleCount / safeTotal) * 100;

        if (loadMoreAmount) {
          const template =
            loadMoreAmount.dataset.template || "You've viewed [amount] of [count] results";
          loadMoreAmount.textContent = template
            .replace("[amount]", String(visibleCount))
            .replace("[count]", String(totalCount));
        }

        if (progressBar) {
          progressBar.style.setProperty("--percent", `${percent}%`);
          progressBar.style.setProperty("--amount", visibleCount);
          progressBar.style.setProperty("--count", totalCount);
        }
      };

      const revealNextItems = () => {
        const hiddenItems = getHiddenItems();
        hiddenItems.slice(0, step).forEach((item) => {
          item.classList.remove("is-hidden-by-pagination");
        });
        updatePanelProgress();

        if (!getHiddenItems().length) {
          const observer = panelObservers.get(panel);
          if (observer) {
            observer.disconnect();
            panelObservers.delete(panel);
          }
          loadMoreButton.remove();
        }
      };

      loadMoreButton.addEventListener("click", (event) => {
        event.preventDefault();
        revealNextItems();
      });

      if (
        loadMoreButton.classList.contains("collection-panel-load-more--auto") &&
        "IntersectionObserver" in window
      ) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !panel.hidden) {
                revealNextItems();
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMoreButton);
        panelObservers.set(panel, observer);
      }

      updatePanelProgress();
      panel.dataset.paginationInitialized = "true";
    };

    const activateTab = (handle, updateUrl = true) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.collectionHandle === handle;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.collectionHandle !== handle;
        if (!panel.hidden) initPanelPagination(panel);
      });

      if (updateUrl) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set("collection", handle);
          window.history.replaceState({}, "", url.toString());
        } catch (error) {
          // noop
        }
      }
    };

    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
        activateTab(button.dataset.collectionHandle);
      }, true);
    });

    const initialHandle =
      section.querySelector(".collection-button.is-active")?.dataset.collectionHandle ||
      section.querySelector(".collection-panels")?.dataset.selectedHandle ||
      buttons[0].dataset.collectionHandle;

    activateTab(initialHandle, false);
    panels.forEach((panel) => initPanelPagination(panel));
    section.dataset.tabsInitialized = "true";
  });
};

document.addEventListener("DOMContentLoaded", () => initCollectionTabs(document));
document.addEventListener("shopify:section:load", (event) => initCollectionTabs(event.target));

class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
  }

  initLoadMore() {
    const countElement = document.getElementById("load-more-container");
    if (!countElement) return;
    const count = countElement.getAttribute("data-count");
    this.querySelectorAll(".actions-load-more").forEach((loadMore) => {
      var _this = this;
      if (loadMore.classList.contains("infinit-scrolling")) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                _this.loadMorePosts(loadMore, count);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMore);
      } else {
        loadMore.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMorePosts(target, count);
          },
          false
        );
      }
    });
  }

  loadMorePosts(target, count) {
    const loadMore_url = target.getAttribute("href");
    const _this = this;
    _this.toggleLoading(target, true);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const resultNodes = parser.parseFromString(responseText, "text/html");
      
        // ✅ SOLO UNA VEZ (selector correcto)
        const newProducts = resultNodes.querySelectorAll(
          "#section__content-items > .item-load"
        );
      
        newProducts.forEach((prodNode) => {
          document
            .getElementById("section__content-items")
            .appendChild(prodNode);
        });
      
        // ✅ FIX imágenes lazy
        const images = document.querySelectorAll("#section__content-items img");
        images.forEach((img) => {
          if (img.hasAttribute("data-srcset")) {
            img.setAttribute("srcset", img.getAttribute("data-srcset"));
            img.removeAttribute("data-srcset");
          }
        });
      
        // ✅ GET NEXT PAGE LINK
        const load_more = resultNodes.querySelector("loadmore-button a");
      
        // ✅ TOTAL REAL DESDE RESPONSE
        const newCountEl = resultNodes.getElementById("load-more-container");
        let total = 0;
      
        if (newCountEl) {
          total = parseInt(newCountEl.getAttribute("data-count"));
        }
      
        // ✅ LOADED REAL (ESTE ERA TU BUG)
        const loaded = document.querySelectorAll(
          "#section__content-items .item-load"
        ).length;
      
        // ✅ UPDATE TEXTO
        const loadMoreAmount = document.querySelector(".load-more-amount");
        if (loadMoreAmount) {
          loadMoreAmount.innerHTML = `You've viewed ${loaded} of 5 results`;
        }
      
        // ✅ UPDATE LINK O REMOVE
        if (load_more) {
          target.setAttribute("href", load_more.getAttribute("href"));
        } else {
          target.remove();
        }
      
        _this.updateProgressBar(total);
        _this.toggleLoading(target, false);
      })
      .catch((error) => {
        throw error;
      });
  }

  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? "add" : "remove";
      event.classList[method]("loading");
    }
  }

  updateProgressBar(count) {
    var amount = document.querySelectorAll(
      "#section__content-items .item-load"
    ).length;
    var percent = (amount / count) * 100;
    var progressBar = document.querySelector(".load-more-progress-bar");
    if (!progressBar) return;
    progressBar.style.setProperty("--percent", percent + "%");
    progressBar.style.setProperty("--amount", amount);
  }
}

if (!customElements.get("loadmore-button")) {
  customElements.define("loadmore-button", PaginateLoadmore);
}

class LoadMoreButtonCollection extends HTMLElement {
  constructor() {
    super();
    this.loadMoreButton = this.querySelector("a");
    this.loadMoreElement = document.querySelector(".actions-load-more");
    this.init();
  }

  init() {
    if (!this.loadMoreButton) return;
    
    this.loadMoreButton.addEventListener("click", this.handleClick.bind(this));
    this.loadMoreButton.addEventListener("keydown", this.handleKeydown.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    this.executeLoadMore();
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.executeLoadMore();
    }
  }

  executeLoadMore() {
    this.toggleLoading(true);
    
    setTimeout(() => {
      this.showHiddenCollections();
      this.toggleLoading(false);
      this.cleanup();
    }, 500);
  }

  toggleLoading(isLoading) {
    if (this.loadMoreElement) {
      this.loadMoreElement.classList.toggle("loading", isLoading);
    }
    
    if (this.loadMoreButton) {
      this.loadMoreButton.classList.toggle("loading", isLoading);
    }
  }

  showHiddenCollections() {
    const hiddenItems = document.querySelectorAll(
      ".section__collections-list .collection-item.hidden"
    );
    
    hiddenItems.forEach((item) => {
      item.classList.remove("hidden");
    });
  }

  cleanup() {
    this.remove();
  }
}

if (!customElements.get("loadmore-button-collection")) {
  customElements.define("loadmore-button-collection", LoadMoreButtonCollection);
}
